<template>
  <div v-if="IsCompleteable">
    <router-btn :text="$t('servicesystem.common_objects.commonterms.complete')" :icon="jobCompleteIcon"
      :color="'primary'" :disabled="!IsCompleteable" :loading="loading" :textbtn="textbtn" :large="large" :small="small"
      @Press="action()">
    </router-btn>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "CompleteJobBtn",
  props: ["large", "small", "textbtn"],
  components: {
    RouterBtn,
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
    };
  },

  created() { },

  mounted() { },

  methods: {
    async action() {
      this.loading = true;
      this.SetJobStatus(this.$route.params.jobId, 50, null)
        .then((result) => {
          this.$store.dispatch("JobHub/JobParentjob/setJobDetail", { key: "JobStatusId", value: result });
          this.$store.dispatch("JobHub/JobParentjob/setNewJobDetail", { key: "JobStatusId", value: result });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {
    jobCompleteIcon() {
      return this.statusicon(50);
    },

    IsCompleteable() {
      return this.$store.getters["JobHub/IsCompleteable"];
    },
    JobStatus() {
      return this.$store.getters["JobHub/JobStatus"];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
